import React from 'react';
import { Button } from '@/components/shared/button';
import { Save } from 'lucide-react';
import { Weights, OpportunityScore } from '@/types/opportunity';
import { useSaveAssessment } from '@/hooks/useSaveAssessment';
import { useToast } from '@/hooks/use-toast';

interface SaveAssessmentButtonProps {
  weights: Weights;
  scoredOpportunities: OpportunityScore[];
}

const SaveAssessmentButton = ({ weights, scoredOpportunities }: SaveAssessmentButtonProps) => {
  const { handleSave, isSaving } = useSaveAssessment(weights, scoredOpportunities);
  const { toast } = useToast();

  const onSave = async () => {
    console.log('Starting save with data:', { weights, scoredOpportunities });
    
    toast({
      title: "Saving Assessment...",
      description: "Please wait while we save your progress.",
    });

    try {
      await handleSave();
      console.log('Save completed successfully');
      
      toast({
        title: "Assessment Saved",
        description: "Your assessment has been saved successfully.",
        variant: "default",
        className: "bg-green-50 border-green-200",
      });
    } catch (error) {
      console.error('Error during save:', error);
      
      toast({
        title: "Error Saving",
        description: "Failed to save assessment. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Button
      variant="outline"
      onClick={onSave}
      className="gap-2"
      disabled={isSaving}
    >
      <Save className="w-4 h-4" />
      {isSaving ? 'Saving...' : 'Save'}
    </Button>
  );
};

export default SaveAssessmentButton;